import { useCallback } from "react";
import { Row, Col, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import LatestNews from "../components/LatestNews";
import LatestPosts from "../components/LatestPosts";
import MemberPageCarousel from "../components/MemberPageCarousel";
import ErrorBoundary from "../components/ErrorBoundary";

import bboard from "../assets/images/bboard.png";
import memdir from "../assets/images/memdir.png";
import calendar from "../assets/images/calendar.png";
import gallery from "../assets/images/gallery.png";
import news from "../assets/images/news.png";

// Quick Link Card Component
const QuickLinkCard = ({ image, title, path }) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => {
    navigate(path);
  }, [navigate, path]);

  return (
    <Card
      className="member-screen-links text-center h-100 shadow-sm hover-shadow"
      style={{ cursor: "pointer" }}
      onClick={handleClick}
    >
      <Card.Body className="d-flex flex-column align-items-center justify-content-center p-2 p-md-3">
        {/* Hide images on mobile, show on larger screens */}
        <div className="d-none d-md-block mb-3">
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              maxWidth: "128px",
              height: "auto",
              aspectRatio: "1",
              objectFit: "cover",
              borderRadius: "50%",
              transition: "transform 0.2s ease-in-out",
            }}
            className="hover-scale"
          />
        </div>
        <Card.Title className="mt-auto fs-6 fs-sm-7">{title}</Card.Title>
      </Card.Body>
    </Card>
  );
};

QuickLinkCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

// Quick Links Data
const quickLinks = [
  { image: news, title: "News", path: "/news" },
  { image: gallery, title: "Gallery", path: "/gallery" },
  { image: bboard, title: "Bulletin Board", path: "/bb" },
  { image: memdir, title: "Directory", path: "/directory" },
  { image: calendar, title: "Calendar", path: "/calendar" },
];

const MemberScreen = () => {
  return (
    <ErrorBoundary>
      <div className="member-screen">
        <MemberPageCarousel />

        <div className="member-page-container container-fluid px-3 px-md-4 px-lg-5">
          {/* Latest Updates Section */}
          <Row className="mt-4 mt-md-5 justify-content-center">
            <Col xs={12} md={8} className="p-2">
              <ErrorBoundary>
                <LatestNews />
              </ErrorBoundary>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs={12} md={8} className="p-2">
              <ErrorBoundary>
                <LatestPosts />
              </ErrorBoundary>
            </Col>
          </Row>

          {/* Quick Links Section */}
          <Row className="my-4 my-md-5 justify-content-center g-1 g-md-3">
            {quickLinks.map((link) => (
              <Col
                key={link.path}
                xs={2}
                sm={2}
                md={3}
                lg={2}
                className="p-1 p-md-2"
              >
                <QuickLinkCard {...link} />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default MemberScreen;
